export const INVALID_SELECTOR = "[aria-invalid='true']";

/** Na próxima frame (depois que FormSection/Tabs abriram o que tinha erro), foca o primeiro campo inválido visível (FE11). */
export function focusFirstInvalid(root: ParentNode = document) {
  requestAnimationFrame(() => {
    const el = [...root.querySelectorAll<HTMLElement>(INVALID_SELECTOR)].find((e) => !e.closest("[hidden]"));
    el?.focus();
  });
}
